import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './i18n/i18n';  // Import i18n configuration
import { createAppKit } from '@reown/appkit/react'
import { polygon, mainnet } from '@reown/appkit/networks'
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi'
import { WagmiProvider } from 'wagmi'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
const projectId = process.env.REACT_APP_WALLET_CONNECT_PROJECT_ID;
// console.log('project id', projectId);
const queryClient = new QueryClient()

const metadata = { //optional
    name: 'BitBitWin',
    description: 'BitBitWin - Decentralized Lottery',
    url: 'https://example.com',
    icons: ['https://avatars.githubusercontent.com/u/179229932']
}

const wagmiAdapter = new WagmiAdapter({
  networks: [polygon,mainnet],
  projectId,
  providerConfig: {
    enableWebSocketProvider: true
  }
})
const appKit = createAppKit({
  adapters: [wagmiAdapter],
  networks: [mainnet, polygon],
  metadata: metadata,
  projectId,
  features: {
    analytics: true,
    email: false, // default to true
    socials: false,
    emailShowWallets: false, // default to true
  }
})
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <WagmiProvider config={wagmiAdapter.wagmiConfig}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </WagmiProvider>
  </React.StrictMode>
);
